

export * from "@baseline/web/routing/legacy/route-path";

